export default __webpack_public_path__ + "fd46a69b975105c4307184133e3b2f09.png";